'use client';

import dynamic from 'next/dynamic';
import { PropsWithChildren } from 'react';

const _NoSSR = ({ children }: PropsWithChildren) => {
  return children;
};

export const NoSSR = dynamic(() => Promise.resolve(_NoSSR), {
  ssr: false,
});
